import { Card, Space, Tag, Typography } from 'antd'
import { useAnswer } from '../../contexts/AnswerContext'
import { useFormEditor } from '../../contexts/FormContext'

const { Text } = Typography

interface Props {}

export const ManagerAnswerReadOnly = ({}: Props) => {
  const { manager } = useFormEditor()
  const { item, answer } = useAnswer()

  if (
    manager === undefined ||
    manager === null ||
    item === undefined ||
    answer === undefined ||
    !item.isAnswerableByManager
  )
    return <></>

  const answerContent = answer.managerAnswer ? (
    answer.managerAnswer
  ) : (
    <Space>
      {answer.managerOptions &&
        answer.managerOptions.map((option) => (
          <Tag key={option.id}>{option.name}</Tag>
        ))}
    </Space>
  )

  return (
    <Card styles={{ body: { padding: 10 } }}>
      <Text type="secondary">
        Réponse de {manager.firstName} : {answerContent}
      </Text>
    </Card>
  )
}
